const customerReferralFormsEls = document.querySelectorAll('.customer-referral-forms');

customerReferralFormsEls.forEach((customerReferralFormsEl) => {
    // prettier-ignore
    const selectionOptionForm = customerReferralFormsEl.querySelector('.customer-referral-forms__selection-option-form');
    const formContainer = customerReferralFormsEl.querySelector('.customer-referral-forms__form-container');

    if (selectionOptionForm && selectionOptionForm && formContainer) {
        selectionOptionForm.addEventListener('click', () => {
            selectionOptionForm.classList.toggle('customer-referral-forms__selection-option-form--active');
            formContainer.classList.toggle('customer-referral-forms__form-container--active');
        });
    }
});
